import { connect } from "react-redux";
import _ from "lodash";
import AssetShareAnalyticsView from "./view";
import { fetchAssetAnalytics } from "src/legacy/redux/actions/rolodex";
import { fetchPreviewAsset } from "src/legacy/redux/actions/assets.jsx";
import withUseHooks from "src/legacy/components/withUseHooks";

const mapStateToProps = (state, ownProps) => {
  const share = state.legacyRootReducer.rolodex.contact.shares.items.find((share) => {
    if (!share) {
      return;
    }

    if (share.id == _.get(ownProps, 'location.query.share', null)) {
      return share;
    }
  });
  const section = share?.sections?.length &&
    share.sections.find((section) => {
      if (section.id == _.get(ownProps, 'location.query.section', null)) {
        return section;
      }
    });

  if (section) {
    var asset = section.assets.length && section.assets.find((asset) => {
      return asset.id == _.get(ownProps, 'location.query.asset', null);
    });
  } else {
    var asset = share.assets.length &&
      share.assets.find((asset) => {
        if (asset.id == _.get(ownProps, 'location.query.asset', null)) {
          return asset;
        }
      });
  }
  return {
    asset: asset,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAssetAnalytics: (contactID, shareID, sectionID, assetID) => {
      return dispatch(
        fetchAssetAnalytics(contactID, shareID, sectionID, assetID)
      );
    },
    fetchPreviewAsset: (assetID) => {
      return dispatch(fetchPreviewAsset(assetID));
    },
  };
};

const AssetShareAnalyticsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetShareAnalyticsView);

export default withUseHooks(AssetShareAnalyticsContainer);